export function removeEmoji(t: HTMLInputElement) {
  var ranges = [
    '\ud83c[\udf00-\udfff]',
    '\ud83d[\udc00-\ude4f]',
    '\ud83d[\ude80-\udeff]',
    '\ud7c9[\ude00-\udeff]',
    '[\u2600-\u27BF]'
  ];
  var reg = new RegExp(ranges.join('|'), 'g');
  t.value = (t.value).replace(reg, '');
}

export function removeHtmlTag(t: HTMLInputElement) {
  t.value = (t.value).replace(/<[^>]*>?/g, '');
}

export function removeUrl(t: HTMLInputElement) {
  t.value = (t.value).replace(/https?:\/\/[^\s]+/g, '');
}

export function hankakuToZenkaku(t: HTMLInputElement) {
  t.value = (t.value).replace(/[A-Za-z0-9]/g, function(s) {
    return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
  });
}

export function zenkakuToHankaku(t: HTMLInputElement) {
  t.value = (t.value).replace(/[Ａ-Ｚａ-ｚ０-９－ー]/g, function(s) {
    if (s === '－' || s === 'ー') {
      return '-';
    }
    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
  });
}

// iframe内の時とiframe外の時でリンクを切り替える
// 例: linkToIframe('login', { isIframeUrl: `${WP_URL}/login` })
// src/utils/linkToIframe.ts
// utils/linkToIframe.ts
export function linkToIframe(
  
  pathOrUrl: string,
  { isIframeUrl }: { isIframeUrl?: string | null } = {}
) {
  const inIframe = window.self !== window.top;
  const isAbs = /^https?:\/\//i.test(pathOrUrl);

  // ① 親(top)を遷移（WP/外部）
  if (inIframe && isIframeUrl) {
    try {
      window.top!.location.assign(isIframeUrl);
      return;
    } catch {
      window.parent.postMessage({ type: 'navigate', href: isIframeUrl }, '*');
      return;
    }
  }

  // ② iframe内だけで React の画面に切替えたい (/user/*)
   if (inIframe && !isAbs) {
    // 受け取りは '/user/info' でも '/info' でも可
    const BASENAME = '/user'; // BrowserRouter の basename に合わせて
    let p = pathOrUrl.trim();
    if (!p.startsWith('/')) p = '/' + p;
    if (!p.startsWith(BASENAME + '/')) {
      // '/info' のように basename なしで来たら補完
      p = BASENAME + p;
    }
    // ← ここがポイント：リロードせずに URL だけ更新
    window.history.pushState({}, '', p);
  
    // React Router にURL変更を通知（不要な場合もあるが安全）
    window.dispatchEvent(new PopStateEvent('popstate'));
    return;
   }

  // ③ それ以外は通常遷移（外部URLなど）
  window.location.assign(pathOrUrl);
}

